export default function Badge() {
	return (
		<div className="flex flex-col lg:w-[172px] h-[107px] lg:h-auto justify-center items-center gap-2 p-4 bg-gray-200 rounded-xl">
			<div className="h-6 w-[40%] animate-pulse rounded-lg bg-gray-100 dark:bg-gray-700" />
			<div className="h-4 w-[90%] animate-pulse rounded-lg bg-gray-100 dark:bg-gray-700" />
		</div>
	);
}
